import { Component, OnInit, ViewChild, ViewEncapsulation, Input, OnDestroy, AfterViewInit, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';

import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';

//import constants
import { AppSettings } from '../../../../../constants/app-settings';
import { AppFrontRoutes } from '../../../../../constants/app-front-routes';

//import services
import { ServicingService } from '../../../../../services/servicing.service';
import { ConfirmationDialogService } from '../../../../general/modals/confirmation/confirmation.service';
import { GeneralService } from '../../../../../services/general.service';
import { AuditCreateComponent } from '../../audit-create/audit_create.component';
import { AuditService } from 'src/app/services/audit.service';
import { formatDate } from '@angular/common';
import { CommonUtility } from "../../../../../utility/commonUtility"
import { fromEvent } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
declare var $: any;

@Component({
  selector: 'app-audit-view',
  templateUrl: './audit-view.component.html',
  styleUrls: ['./audit-view.component.css'],
  encapsulation: ViewEncapsulation.None

})

export class AuditViewComponent implements OnDestroy, OnInit, AfterViewInit {
  getPhotoBase64;
  @ViewChild('search') search;
  dropdownList = [];
  dropdownList1 = [];
  dropdownList2 = [];
  dropdownList3 = [];
  selectedItems = [];
  dropdownSettings = {};
  dropdownSettings1 = {};
  dropdownSettings2 = {};
  dropdownSettings3 = {};
  data: any;
  temp: any;
  readonly AppSettings = AppSettings;
  readonly AppFrontRoutes = AppFrontRoutes;

  datatableOptions1: any;
  datatableOptions2: any;
  datatableOptions3: any;
  datatableOptions4: any;
  datatableTrigger1: Subject<any> = new Subject();
  datatableColsDefs1: any;
  datatableColsDefs2: any;
  datatableColsDefs3: any;
  datatableColsDefs4: any;
  datatableCols1: any;
  datatableCols2: any;
  datatableCols3: any;
  datatableCols4: any;
  datatableAddCols1: any;

  @Input() filter1: string;
  @Input() filter2: string;
  @Input() filter3: string;
  @Input() filter4: string;
  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  addServicingModal: BsModalRef;
  viewServicingModal: BsModalRef;
  addExtraModel: BsModalRef;
  addMaintenanceModel: BsModalRef;
  addAuditModal: BsModalRef;
  deleteOption: any;
  extraordinayModal: BsModalRef;
  ordinayModal: BsModalRef;
  ordinary_data: BsModalRef;

  lang: any;
  odlang: any;
  exodlang: any;
  generalData: any;
  mLang: any;
  maintenanceData: any;
  records: any;
  single_data: any;
  plans: any;
  imgQR: any;
  exordinary_data: any;
  documents_data: any;
  planvals: any;
  cnt: any;
  doclang: any;
  selectedTab: any;
  selectedVal: any;
  selDropdownList: any;
  pageView: string = 'list';
  timezone = localStorage.getItem('timezone');
  generatePlanType:string = ""
  id: number;
  evaluvationForm: FormGroup;
  docsForm: FormGroup;
  createMailForm: FormGroup;
  generalsForm: FormGroup;
  generalsFormSubmitted: Boolean = false;
  createMailFormSubmitted: Boolean = false;
  generalsFormMsg: any;
  rolepermission: any;
  selectedLang = "1"
  disableField:boolean = true;
  docsInfo;
  remarkLang;
  evaluvationFormSubmitted:boolean = false;
  docInfo:SafeHtml;
  constructor(
    private formBuilder: FormBuilder,
    private servicingService: ServicingService,
    private modalService: BsModalService,
    private confirmationDialogService: ConfirmationDialogService,
    private route: ActivatedRoute,
    private router: Router,
    private generalService: GeneralService,
    private ngxRolesService: NgxRolesService,
    private auditService: AuditService,
    private utility: CommonUtility,
    private sanitizer: DomSanitizer,
    private elementRef:ElementRef
  ) { }


  ngOnInit() {
    //fetch data

    this.mailFormBuild()
    this.data = this.route.snapshot.data['sdata'];
    // console.log(this.data);  

    var role = this.ngxRolesService.getRole('servicing');

    this.rolepermission = '';
    if (role) {
      this.rolepermission = role.validationFunction[0];
    }

    this.selectedTab = 'auditplan';

    if (this.selectedTab != "") {
      this.selectedTab = this.selectedTab;
    }
    else {
      this.selectedTab = 'auditplan';
    }

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: false,
      itemsShowLimit: 3,
      allowSearchFilter: true
    };    

    
    this.getData();
    this.tab2Actions();
    this.formBuildDocs()
    this.formBuildEvaluvation()
    
  }

  timetable_link_uploaded(): FormArray {
    if(this.docsForm.get('timetable_link_uploaded'))
      return this.docsForm.get('timetable_link_uploaded') as FormArray;
  };

  removeDocs(i: number) {
    this.timetable_link_uploaded().removeAt(i);
  }

  newAttachment(): FormGroup {
    return this.formBuilder.group({
      attachments: ['']
    });
  }

  addDocs(): void {
    this.timetable_link_uploaded().push(this.newAttachment());
  }
    
  selectAttachment(event: any, index) {

    this.docsForm.value.timetable_link_uploaded[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      
      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
          this.docsForm.value.timetable_link_uploaded[index].link = {'name': file.name, 'image': reader.result};
      };
    }
    
  }  

  formBuildDocs(){
    this.docsForm = this.formBuilder.group({
      timetable_link_uploaded: this.formBuilder.array([this.newAttachment()]),
      audit_uploaded: this.formBuilder.array([]),
      audit_id: '',
      standard_id: '',
      chapter_id: '',
      clause_id: '',      
    });

    setTimeout(() => this.fileDesign(), 10);

    this.timetable_link_uploaded().valueChanges.subscribe(values => {
      setTimeout(() => this.fileDesign(), 10);
    });    
  }

  audit_uploaded(): FormArray {
    return this.docsForm.get('audit_uploaded') as FormArray;
  };

  removeAuditUploaded(i: number) {
    this.audit_uploaded().removeAt(i);
  }


  fileDesign(){
    $(".filestyle").filestyle({
      'htmlIcon': '<i class="fa fa-inbox mr-5"></i>',
      'btnClass': 'btn-default',
    });
  }

  saveDocs(){
    // this.evaluvationFormSubmitted = true
    console.log(this.docsForm.value)
    if(this.docsForm.valid){
      this.auditService.saveDocsForm(this.docsForm.value).subscribe(
        res =>{ 
          this.generalService.notify_msg('success', res.msg);
        },
        error => {
          this.generalService.notify_msg('error', "unable to update now");
        })      
    }
  }

  saveEvaluvation(type){
    this.evaluvationFormSubmitted = true
    if(this.evaluvationForm.valid){
      this.auditService.saveDocsForm(this.evaluvationForm.value).subscribe(
        res =>{ 
          this.fileDesign()
          if(type == 2) this.switch_tab('tab3_li')
          this.generalService.notify_msg('success', res.msg);
        },
        error => {
          this.generalService.notify_msg('error', "unable to update now");
        })      
    }
    
  }

  formBuildEvaluvation(){
    this.evaluvationForm = this.formBuilder.group({
      notes: ['', [Validators.required]],
      remarks: this.formBuilder.array([]),
      audit_id: '',
      standard_id: '',
      chapter_id: '',
      clause_id: '',
      action: 'update_clause',
    });    
    // this.newRemarks()
  }

  deleteRemarks(index){
    const remarks = this.evaluvationForm.get('remarks') as FormArray;
    remarks.removeAt(index);    
  }

  newRemarks(title = '', type = '') {
    const add = this.evaluvationForm.get('remarks') as FormArray;
    add.push(this.formBuilder.group({
      remark_title: [title,[Validators.required]],
      remark_type: [type]
    }))
  }

  ngAfterViewInit(){

    const that = this
    setTimeout(function(){
      console.log(this.search)
      fromEvent(this.search, 'keydown')
      .pipe(
        debounceTime(550),
        map(x => x['target']['value'])
      )
      .subscribe(value => {
        that.single_data.output3.mail_records = that.utility.updateFilter(value,that.datatableCols2,that.single_data.output3.mail_records,that.temp)
      });  
    },3000)    

  }  

  onItemSelect(item: any) {
    console.log(item.item_id);
  }
  onSelectAll(items: any) {
    console.log(items);
  }


  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
  }

  pdfDownload(url, name) {

    this.generalService.getAssets(url)
      .subscribe(
        (val) => {

          const url = URL.createObjectURL(val);
          this.downloadUrl(url, name);
          URL.revokeObjectURL(url);
        });
  }

  create_report(){
    let selectLang = this.selectedLang
    let audit_id   = this.id
    this.auditService.generateAuditPlanReport({"language_id":selectLang,"audit_id":audit_id},this.generatePlanType).subscribe(
      res =>{
        if(this.generatePlanType == "audit_plan")
          var view_url = 'http://vmi313621.contaboserver.net/Software_backend/uploads/audit/audit_plan/'+res.filename;
        else
        var view_url = 'http://vmi313621.contaboserver.net/Software_backend/uploads/audit/audit_report/'+res.filename;
        window.open(view_url, '_blank');
        $("#generate_report_pdf").modal("hide");
      })      
  }

  showMailModal(type){
    $("#show_mail_modal").modal("show");
    this.createMailForm.patchValue({
      "type":type,
      "audit_id":this.id
    })
   
  }

  generate_report_pdf(type){
    this.generatePlanType = type
    $("#generate_report_pdf").modal("show");
  }

  onMailSubmit(){
    this.createMailFormSubmitted = true
    if(this.createMailForm.valid){
      const type = this.createMailForm.get('type').value
      this.auditService.sendAuditMail(type,this.createMailForm.value).subscribe(
        res =>{ 
          this.generalService.notify_msg('success', res.msg);
          $("#show_mail_modal").modal("hide");
          this.getData()
        },
        error => {
          this.generalService.notify_msg('error', "unable to send mail");
        })
    }

  }

  trigger_mail(mail_id,audit_id){
    this.auditService.triggerReportMail(audit_id,mail_id)
    .subscribe(
      (res) => {
        if (res.status){
          this.generalService.notify_msg('success', res.msg);
        }else{
          this.generalService.notify_msg('error', res.msg);
        }
        this.getData()
      });    
  }

  mailFormBuild(): void {

    this.createMailForm = this.formBuilder.group({
      sender: ['demo@kaizencloud.eu', [Validators.required]],
      recipients: ['', [Validators.required]],
      cc: [],
      subject: [],
      message: ['', [Validators.required]],
      audit_id:[this.id],
      type:[]
    });
  }

  openPDFLink(){
    let audit_id   = this.id
    this.auditService.getAuditUserData().subscribe(
      res =>{
        var view_url = "http://vmi313621.contaboserver.net/Software_backend/index.php/common/audit_plan_report_view/"+this.id+"/"+res.data.user_id
        window.open(view_url, '_blank');
      })     
  }

  downloadUrl(url: string, fileName: string) {
    const a: any = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.style = 'display: none';
    a.click();
    a.remove();
  };

  datatableConfig(): void {

    this.datatableColumns();

    this.datatableOptions1 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs1,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table1 = new $.fn.dataTable.Api('#table1');

          var count = table1.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table1.rows().deselect();
            selected = false;
          }
          else
            table1.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table1 = new $.fn.dataTable.Api('#table1');

        table1
          .on('select deselect', function (e, dt, type, indexes) {

            var table1 = new $.fn.dataTable.Api('#table1');
            var selected = table1.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons1 = new $.fn.dataTable.Buttons(table1, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {
              extend: 'csv',
              text: 'Export CSV',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'pdfHtml5',
              text: 'Export PDF',
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'excel',
              text: 'Export Excel',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
            {
              extend: 'print',
              text: 'Print',
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table1');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud"
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn1'));

      }
    }


    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';
    this.filter4 = '';

  }


  datatableConfig1(): void {

    this.datatableColumns1();

    this.datatableOptions2 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs2,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table2 = new $.fn.dataTable.Api('#table2');

          var count = table2.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table2.rows().deselect();
            selected = false;
          }
          else
            table2.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table2 = new $.fn.dataTable.Api('#table2');

        table2
          .on('select deselect', function (e, dt, type, indexes) {

            var table2 = new $.fn.dataTable.Api('#table2');
            var selected = table2.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons2 = new $.fn.dataTable.Buttons(table2, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {
              extend: 'csv',
              text: this.exodlang.exportCsv,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod DEMO Service " + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
            {
              extend: 'pdfHtml5',
              text: this.exodlang.exportPdf,
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCluod DEMO Service " + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
            {
              extend: 'excel',
              text: this.exodlang.exportExcel,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod DEMO Service " + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
            {
              extend: 'print',
              text: this.exodlang.exportPrint,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table2');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCluod DEMO Service " + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn2'));

      }
    }

    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';
    this.filter4 = '';

  }


  datatableConfig2(): void {
    this.datatableColumns2();

    this.datatableOptions3 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs3,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {
        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          let vcnt = $('th:first-child input').val();
          // console.log(vcnt);

          $('.dmulval').val('');

          for (let i = 1; i <= vcnt; i++) {
            if ($('.chk' + i).is(":checked")) {
              var table3 = new $.fn.dataTable.Api('.otable' + i);

              var count = table3.rows({ selected: true }).count();
              let selected = true;

              if (count > 0) {
                table3.rows().deselect();
                selected = false;
              }
              else
                table3.rows().select();

              $('th:first-child input', thead).prop("checked", selected);
              $('.odplus_del' + i).css('display', 'inline-block');
            }
            else {
              var table3 = new $.fn.dataTable.Api('.otable' + i);
              var count = table3.rows({ selected: true }).count();
              let selected = true;

              if (count > 0) {
                table3.rows().deselect();
                selected = false;
              }
              $('.odplus_del' + i).css('display', 'none');
            }
          }

          // var table3 = new $.fn.dataTable.Api('.otable1');

          // var count = table3.rows({ selected: true }).count();
          // let selected = true;

          // if (count > 0) {
          //   table3.rows().deselect();
          //   selected = false;
          // }
          // else
          //   table3.rows().select();

          // $('th:first-child input', thead).prop("checked", selected);

        });
      },
      // }
    }

  }

  odatatableExport(val) {

    $('.scol_val').val(val);
    $('#odatatableExport3').modal('show');
    // $('#datatableExportBtn3').show();
    $('#datatableExportBtn3').html('');
    let j = val;
    if (j != "") {

      var table3 = new $.fn.dataTable.Api('.otable' + j);


      var buttons3 = new $.fn.dataTable.Buttons(table3, {
        dom: {
          button: {
            className: ''
          }
        },
        buttons: [
          {
            extend: 'csv',
            text: 'Export CSV',
            className: 'btn btn-info',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('.otable' + j);
                var selected = dt.rows({ selected: true }).indexes().toArray();
                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;

                return false;
              }
            },
            title: "KaizenCluod DEMO Service " + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
          },
          {
            extend: 'pdfHtml5',
            text: 'Export PDF',
            className: 'btn btn-info',
            orientation: 'landscape',
            pageSize: 'A3',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('.otable' + j);
                var selected = dt.rows({ selected: true }).indexes().toArray();

                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;


                return false;
              }
            },
            title: "KaizenCluod DEMO Service " + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
          },
          {
            extend: 'excel',
            text: 'Export Excel',
            className: 'btn btn-info',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('.otable' + j);
                var selected = dt.rows({ selected: true }).indexes().toArray();

                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;

                return false;
              }
            },
            title: "KaizenCluod DEMO Service " + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
          },
          {
            extend: 'print',
            text: 'Print',
            className: 'btn btn-info',
            exportOptions: {
              columns: '.selected',
              rows: function (idx, data, node) {
                var dt = new $.fn.dataTable.Api('.otable' + j);
                var selected = dt.rows({ selected: true }).indexes().toArray();

                if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                  return true;

                return false;
              }
            },
            title: "KaizenCluod DEMO Service " + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
          },
        ], select: true
      }).container().appendTo($('#datatableExportBtn3'));
    }

    $('.scol_val').val('');


  }

  close() {
    $('#odatatableExport3').modal('hide');
    // $('#datatableExportBtn3').detach();
    $('#odatatableExport3').clear();
  }

  onchk(i, j) {
    // console.log($('#'+i).hasClass('selected'));

    $('.dmulval').val('');
    if ($('#' + i).hasClass('selected') == false) {
      $('.odplus_del' + j).css('display', 'inline-block');
      $('.dmulval').val(i);
    }
    else {
      $('.odplus_del' + j).css('display', 'none');
      $('.dmulval').val('');
    }

  }

  datatableConfig3(): void {

    this.datatableColumns3();

    this.datatableOptions4 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs4,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table4 = new $.fn.dataTable.Api('#table4');

          var count = table4.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table4.rows().deselect();
            selected = false;
          }
          else
            table4.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table4 = new $.fn.dataTable.Api('#table4');
        // console.log(table4);
        table4
          .on('select deselect', function (e, dt, type, indexes) {

            var table4 = new $.fn.dataTable.Api('#table4');
            var selected = table4.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

        var buttons3 = new $.fn.dataTable.Buttons(table4, {
          dom: {
            button: {
              className: ''
            }
          },
          buttons: [
            {
              extend: 'csv',
              text: this.doclang.exportCsv,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table4');
                  var selected = dt.rows({ selected: true }).indexes().toArray();
                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud DEMO Documents " + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
            {
              extend: 'pdfHtml5',
              text: this.doclang.exportPdf,
              className: 'btn btn-info',
              orientation: 'landscape',
              pageSize: 'A3',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table4');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;


                  return false;
                }
              },
              title: "KaizenCloud DEMO Documents " + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
            {
              extend: 'excel',
              text: this.doclang.exportExcel,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table4');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud DEMO Documents " + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
            {
              extend: 'print',
              text: this.doclang.exportPrint,
              className: 'btn btn-info',
              exportOptions: {
                columns: '.selected',
                rows: function (idx, data, node) {
                  var dt = new $.fn.dataTable.Api('#table4');
                  var selected = dt.rows({ selected: true }).indexes().toArray();

                  if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                    return true;

                  return false;
                }
              },
              title: "KaizenCloud DEMO Documents " + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en')
            },
          ], select: true
        }).container().appendTo($('#datatableExportBtn4'));

      }
    }

    this.filter1 = '';
    this.filter2 = '';
    this.filter3 = '';
    this.filter4 = '';

  }

  datatableColumns(): void {

    this.datatableColsDefs1 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols1 = [
      { id: 2, value: 'No.', isSelected: false },
      { id: 4, value: 'Description', isSelected: false },
      { id: 5, value: 'Guy', isSelected: false },
      { id: 6, value: 'Badge number', isSelected: false },
      { id: 7, value: 'Factory number', isSelected: false },
      { id: 8, value: 'Brand', isSelected: false },
      { id: 9, value: 'Template', isSelected: false },
      { id: 10, value: 'Date of commissioning', isSelected: false },
      { id: 11, value: 'Place of use', isSelected: false },
      { id: 12, value: 'Resposible', isSelected: false },
      { id: 13, value: 'Attachments', isSelected: false },
      { id: 14, value: 'Maintenance plans', isSelected: false },
      { id: 15, value: 'State of maintenance', isSelected: false },
      { id: 16, value: 'State', isSelected: false },
    ];

  }

  datatableColumns1(): void {
    this.datatableColsDefs2 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols2 = [
      { id: 2, value: this.exodlang.sno, isSelected: false },
      { id: 3, value: this.exodlang.date_of_send, isSelected: false },
      { id: 4, value: this.exodlang.sender, isSelected: false },
      { id: 5, value: this.exodlang.recipients, isSelected: false },
      { id: 6, value: this.exodlang.subject, isSelected: false },
      { id: 7, value: this.exodlang.distribution_status, isSelected: false },
      { id: 8, value: this.exodlang.attatchment, isSelected: false }
    ];

  }


  datatableColumns2(): void {
    this.datatableColsDefs3 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols3 = [
      { id: 2, value: this.odlang.sno, isSelected: false },
      { id: 3, value: this.odlang.executionDate, isSelected: false },
      { id: 4, value: this.odlang.description, isSelected: false },
      { id: 5, value: this.odlang.performer, isSelected: false },
      { id: 6, value: this.odlang.outcome, isSelected: false },
      { id: 7, value: this.odlang.notes, isSelected: false },
      { id: 8, value: this.odlang.option, isSelected: false },
      { id: 9, value: this.odlang.nextintervention, isSelected: false },
      { id: 10, value: this.odlang.referringDate, isSelected: false },
      { id: 11, value: this.odlang.cost, isSelected: false },
      { id: 12, value: this.odlang.attachments, isSelected: false }
    ];

  }


  datatableColumns3(): void {
    this.datatableColsDefs4 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols4 = [
      { id: 2, value: this.doclang.description, isSelected: false },
      { id: 3, value: this.doclang.date, isSelected: false },
      { id: 4, value: this.doclang.revision, isSelected: false },
      { id: 5, value: this.doclang.attachments, isSelected: false },
      { id: 6, value: this.doclang.status, isSelected: false }
    ];

  }


  datatableFilter(): void {

    $.fn['dataTable'].ext.search.push((settings, data, dataIndex) => {
      const filt1 = data[4] || '';
      const filt2 = data[10] || '';
      const filt3 = data[11] || '';
      const filt4 = data[14] || '';

      var status = true;

      let a = this.filter1;
      // console.log(a);
      Object.keys(a).forEach(function (key) {
        if (a[key].item_id && filt1 != a[key].item_id)
          status = false;
        return status;
      });



      let aa = this.filter2;
      Object.keys(aa).forEach(function (key) {
        if (aa[key].item_id && filt2 != aa[key].item_id)
          status = false;
        return status;
      });


      let aaa = this.filter3;
      Object.keys(aaa).forEach(function (key) {
        if (aaa[key].item_id && filt3 != aaa[key].item_id)
          status = false;
        return status;
      });


      let aaaa = this.filter4;
      Object.keys(aaaa).forEach(function (key) {
        if (aaaa[key].item_id && filt4 != aaaa[key].item_id)
          status = false;
        return status;
      });


      return status;

    });

  }

  datatableFilterAction(): void {
    // console.log(DataTables.Api);
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.draw();

      // dtInstance.columns().every(function () {});


    });
  }

  generalsFormInit(): void {


    this.generalsForm = this.formBuilder.group({
      auditorArr: this.formBuilder.array([]),
      audit_no: ['', [Validators.required]],
      standard_id: ['', [Validators.required]],
      notes: ['', [Validators.required]],
      description: ['', [Validators.required]],
      company: ['', [Validators.required]],
      company_address: ['', [Validators.required]],
      company_contact: ['', [Validators.required]],
      iaf_main: ['', [Validators.required]],
      scope_cert: ['', [Validators.required]],
      start_date: ['', [Validators.required]],
      end_date: ['', [Validators.required]],
      chapter_id: ['', [Validators.required]],
      audit_id: this.id,
    });

  }
  FormBuildUpdate(): void {

    this.generalsForm.patchValue({
      audit_no: this.single_data.audit_no,
      standard_id: this.single_data.standard_id,
      notes: this.single_data.notes,
      description: this.single_data.description,
      company: this.single_data.company,
      company_address: this.single_data.company_address,
      company_contact: this.single_data.company_contact,
      iaf_main: this.single_data.iaf_main,
      scope_cert: this.single_data.scope_cert,
      chapter_id: this.single_data.refering_date,
      audit_id: this.id
    });

  }



  getData() {
    this.route.params.subscribe(params => {
      this.id = params.id;

      this.auditService.getAuditInfo(this.id).subscribe(
        res =>{
          this.lang = this.auditService.listLang(res);
          this.single_data = res.data.form_data
          this.temp = this.single_data.output3.mail_records
          // this.auditing = this.single_data
          // this.FormBuildUpdate()
          this.getStandardClauseDropdown(this.single_data.standard_id,this.id)
        })    
    });
  }

  getStandardClauseDropdown(std_id,audit_id){
    this.auditService.getStdClauseDropdown(std_id,audit_id).subscribe(
      res =>{
        this.dropdownList = res.data.dropdown
        this.selDropdownList = res.data.selected_dropdown
      })        
  }  

  getAuditingRef(clause){
    let auditings = this.single_data.output1.audtings
    if(auditings[parseInt(clause.clause_id)])
      return  auditings[parseInt(clause.clause_id)].auditing_reference
    return ''
  }

  getAuditingDate(clause){
    let auditings = this.single_data.output1.audtings
    if(auditings[parseInt(clause.clause_id)]){
      let date = new Date(parseInt(auditings[parseInt(clause.clause_id)].auditing_date) * 1000)
      return  date.toLocaleDateString()
    }
    return ''
  }

  getSelectedValue(clause,value,type){
    let auditings = this.single_data.output1.audtings
    
    if(auditings[parseInt(clause.clause_id)]){
      if(type == "auditor_id")
        return (parseInt(auditings[parseInt(clause.clause_id)].auditor_id) == parseInt(value))?true:false;
      else if(type == "start_hour")
        return (auditings[parseInt(clause.clause_id)].start_hour == value)?true:false;
      else if(type == "end_hour")
      return (auditings[parseInt(clause.clause_id)].end_hour == value)?true:false;        
    }
    return false
  }

  switch_tab(id){
    $('#'+id).click()
  }

  clearFormArray = (formArray: FormArray) => {
    for(var index = 0; formArray.length > index; index++){
      formArray.removeAt(index)
    }
  }

  showDocsInformation(event,clause_id){
    let selectedEle = $(event.currentTarget)
    var standard_id = $(selectedEle).parents('.data_standard').attr('data-standard');
    var chapter_id = $(selectedEle).parents('.data_chapter').attr('data-chapter');
    var action = 'view_clause';
    
    // set form values for evaluvation form
    this.evaluvationForm.patchValue({
      "audit_id":this.id,
      "standard_id":standard_id,
      "chapter_id":chapter_id,
      "clause_id":clause_id,
      "notes": "",           
    })
    this.clearFormArray(this.evaluvationForm.get('remarks') as FormArray)
    this.clearFormArray(this.audit_uploaded())
    // set form values for docs form
    this.docsForm.patchValue({
      "audit_id":this.id,
      "standard_id":standard_id,
      "chapter_id":chapter_id,
      "clause_id":clause_id
    })

    let dataParams = {
      "action":action,
      "audit_id":this.id,
      "standard_id":standard_id,
      "chapter_id":chapter_id,
      "clause_id":clause_id,      
    }

    
 
    this.auditService.getDocsInfoForm(dataParams).subscribe(
      response => {
        
        this.docsInfo = response.data.form_data
        this.remarkLang = response.data.new_lang_data

        if(this.docsInfo.attachments) {
          let images = this.docsInfo.attachments.split(',');
          for (const image of images) {
            this.audit_uploaded().push(new FormControl(image.split('/').pop()));
          }
        }           
        // prefill evaluvation form
        this.evaluvationForm.patchValue({
          "notes":this.docsInfo.notes
        })
        for(let row of this.docsInfo.remarks){
          this.newRemarks(row.remark_title,row.remark_type)
        }
        // this.generalService.notify_msg('success', "Data updated successfully");
      },
      error => {
        this.docInfo = ""
        // this.generalService.notify_msg('error', "unable to load. please try later...");
      }
    )
  }


  addRemarks(){    
    this.auditService.addRemarks().subscribe(
      response => {
          const that = this
          $(".remarks_parent").append(response.data)
          setTimeout(function(){
            console.log(that.elementRef)
            var d1 = that.elementRef.nativeElement.querySelector('.remarks_parent')            
            console.log(d1)
            if(d1){
              d1.insertAdjacentHTML('beforeend', that.sanitizer.bypassSecurityTrustHtml(response.data));
              // that.elementRef.nativeElement.querySelector('.delete_remarks').addEventListener('click', that.deleteRemarks.bind(that));
            }            
          },1000)          
      },
      error => {
        this.generalService.notify_msg('error', "unable to add remarks now");
      }
    )    
  }  

  saveReq(event){
    let selectedEle = $(event.currentTarget)
    var form = $(selectedEle).parents('.auditing_form');
    var standard_id = $(selectedEle).parents('.data_standard').attr('data-standard');
    var chapter_id = $(selectedEle).parents('.data_chapter').attr('data-chapter');
    var clause_id = $(selectedEle).parents('.auditing_form').attr('data-clause');    
    console.log($(this).parents('.auditing_form'))
    var action = 'update_auditing';
    let dataParams = {
      "action":action,
      "audit_id":this.id,
      "auditor_id":$(form).find("select[name='auditor_id']").val(),
      "standard_id":standard_id,
      "chapter_id":chapter_id,
      "clause_id":clause_id,
      "auditing_reference":$(form).find("input[name='auditing_reference']").val(),
      "auditing_date":$(form).find("input[name='auditing_date']").val(),
      "start_hour":$(form).find("select[name='start_hour']").val(),
      "end_hour":$(form).find("select[name='end_hour']").val(),
    }

    this.auditService.saveAuditing(dataParams).subscribe(
      response => {
        this.generalService.notify_msg('success', "Data updated successfully");
        this.read_mode(selectedEle)
      },
      error => {
        this.generalService.notify_msg('error', "unable to update");
      }
    )

  }


  editReq(event){
    let selectedEle = $(event.currentTarget)
    this.edit_mode(selectedEle)
  }

  read_mode(that){
    $(that).hide();
    console.log($(that).prev('.auditing_edit'))
    $(that).prev('.auditing_edit').css('display', 'block').removeClass('hide');
    $(that).parents('.auditing_form').find(':input').prop("disabled", true);    
  }

  edit_mode(that)
  {
    $(that).hide();
    console.log($(that).next('.auditing_save'))
    $(that).next('.auditing_save').css('display', 'block').removeClass('hide');
    $(that).parents('.auditing_form').find(':input').prop("disabled", false);
  }

  toggle(eve){
    let selectedEle = $(eve.target)
    console.log(selectedEle)
    let target = selectedEle.parents('.standard-values').siblings('.nested');

    selectedEle.toggleClass('open')

    if(selectedEle.hasClass('open')){
      selectedEle.removeClass('fa fa-open').addClass('fa fa-minus')
    }else{
      selectedEle.removeClass('fa fa-minus').addClass('fa fa-plus')
    }

    if (!target.hasClass('active')) {
      target.slideDown().addClass('active');
    } else {
      target.slideUp().removeClass('active');
    }    
  }

  tab2Actions(): void {

    this.route.params.subscribe(params => {
      this.id = params.id;

      this.servicingService.exordinaryData(this.id)
        .subscribe(
          (res) => {


            this.exodlang = this.servicingService.ServicingExOrdinaryLang(res);

            this.exordinary_data = res.data.exordinary_data;

            // console.log(this.exordinary_data);

            //load datatable
            this.datatableConfig1();
            this.datatableFilter();

          }
        );
    });




  }


  tab3Actions(): void {

    this.route.params.subscribe(params => {
      this.id = params.id;

      // console.log(this.data);

      this.servicingService.ordinaryData(this.id)
        .subscribe(
          (res) => {

            this.odlang = this.servicingService.ServicingOrdinaryLang(res);
            // this.ordinary_data = res.data.planvals.ordata;
            this.planvals = res.data.planvals;

            this.cnt = this.planvals.length;

            // console.log(this.planvals);
            // console.log(this.cnt);

            //load datatable
            this.datatableConfig2();


          }
        );
    });


  }

  tab4Actions(): void {

    this.route.params.subscribe(params => {
      this.id = params.id;

      // console.log(params);

      this.servicingService.documentsData(this.id)
        .subscribe(
          (res) => {

            this.doclang = this.servicingService.ServicingDocumentsLang(res);
            this.documents_data = res.data.sdoc_data;
            // console.log(this.documents_data);
            //load datatable
            this.datatableConfig3();
            this.datatableFilter();
          }
        );
    });



  }

  error(msg: any) {
    this.generalService.notify_msg('error', msg);
  }

  redirect() {
    this.router.navigateByUrl('/test', { skipLocationChange: true })
      .then(() => {
        this.router.navigate([AppFrontRoutes.Servicing_List]);
      });
  }

  success(msg: any) {

    //show success message
    this.generalService.notify_msg('success', msg);

    //redirect the current page
    // this.redirect();

    this.router.navigateByUrl('/test', { skipLocationChange: true })
      .then(() => {
        this.router.navigate([AppFrontRoutes.Servicing_List]);
      });
    setTimeout(() => {
      window.location.reload();
    }, 3000);


  }


  export1_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols1.length; i++) {
      this.datatableCols1[i].isSelected = selected;
    }
    this.datatable_export1_choose_column();

  }

  export1_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols1.length; i++) {
      if (this.datatableCols1[i].id == id)
        this.datatableCols1[i].isSelected = selected;
    }

    this.datatable_export1_choose_column();

  }

  datatable_export1_choose_column(): void {

    var table1_name = '#table1';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols1.length; i++) {
      if (this.datatableCols1[i].isSelected)
        table1.column(parseInt(this.datatableCols1[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols1[i].id)).deselect();
    }

  }



  export2_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols2.length; i++) {
      this.datatableCols2[i].isSelected = selected;
    }
    this.datatable_export2_choose_column();

  }

  export2_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols2.length; i++) {
      if (this.datatableCols2[i].id == id)
        this.datatableCols2[i].isSelected = selected;
    }

    this.datatable_export2_choose_column();

  }

  datatable_export2_choose_column(): void {

    var table1_name = '#table2';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols2.length; i++) {
      if (this.datatableCols2[i].isSelected)
        table1.column(parseInt(this.datatableCols2[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols2[i].id)).deselect();
    }

  }


  export3_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols3.length; i++) {
      this.datatableCols3[i].isSelected = selected;
    }
    this.datatable_export3_choose_column();

  }

  export3_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols3.length; i++) {
      if (this.datatableCols3[i].id == id)
        this.datatableCols3[i].isSelected = selected;
    }

    this.datatable_export3_choose_column();

  }

  datatable_export3_choose_column(): void {

    let vcnt = $('th:first-child input').val();
    // console.log(vcnt);

    for (let j = 1; j <= vcnt; j++) {

      var table1_name = '.otable' + j;
      var table1 = new $.fn.dataTable.Api(table1_name);

      for (var i = 0; i < this.datatableCols3.length; i++) {
        if (this.datatableCols3[i].isSelected)
          table1.column(parseInt(this.datatableCols3[i].id)).select();
        else
          table1.column(parseInt(this.datatableCols3[i].id)).deselect();
      }
    }

  }




  export4_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols4.length; i++) {
      this.datatableCols4[i].isSelected = selected;
    }
    this.datatable_export4_choose_column();

  }

  export4_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols4.length; i++) {
      if (this.datatableCols4[i].id == id)
        this.datatableCols4[i].isSelected = selected;
    }

    this.datatable_export4_choose_column();

  }

  datatable_export4_choose_column(): void {

    var table1_name = '#table4';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols4.length; i++) {
      if (this.datatableCols4[i].isSelected)
        table1.column(parseInt(this.datatableCols4[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols4[i].id)).deselect();
    }

  }



  // addServicing() {

  //   this.addServicingModal = this.modalService.show(ServicingCreateComponent, { class: 'modal-lgs', initialState: { 'ID': '', 'langs': this.lang } });
  // }
  // setPageView(view) {
  //   this.pageView = view;
  // }

  // // addExtra() {

  // //   this.addExtraModel = this.modalService.show(ServicingExtraComponent, { class: 'modal-lgs', initialState: { 'ID': '', 'langs': this.lang } });
  // // }




  // addMaintenance(SID, SPID, OID) {
  //   this.addMaintenanceModel = this.modalService.show(ServicingMaintenance, { class: 'modal-lgs', initialState: { 'SID': SID, 'SPID': SPID, 'OID': OID, 'action': 'modify', 'langs': this.lang } });
  // }

  editAudit(ID) {
    this.addAuditModal = this.modalService.show(AuditCreateComponent, { initialState: { 'ID': ID, 'langs': this.lang, 'redirect': 'view' } });
  }


  // viewServicing() {

  //   this.viewServicingModal = this.modalService.show(ServicingViewserviceComponent, { class: 'modal-lgs', initialState: { 'langs': this.lang } });

  // }



  delete(audit_id,mail_id) {

    this.confirmationDialogService.confirm('Delete Confirmation', 'Are you sure to delete?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.auditService.deleteAuditReportMail(audit_id,mail_id)
            .subscribe(
              (res) => {
                if (res.status){
                  this.generalService.notify_msg('success', res.msg);
                }else{
                  this.generalService.notify_msg('error', res.msg);
                }
                this.getData()
              });

        });
  }


  delete_extraordinary(ID) {

    this.confirmationDialogService.confirm('Servicing Delete Confirmation', 'Do you want to delete this?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.delete_extraordinary(ID)
            .subscribe(
              (res) => {
                // if (res.status)
                //   this.success(res.msg);
                // else
                //   this.error(res.msg);

                if (res.status) {
                  this.generalService.notify_msg('success', res.msg);

                  this.router.navigateByUrl('/test', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate([AppFrontRoutes.SERVICING_VIEW + '/' + this.id]);
                    });
                    localStorage.setItem('selectedVal', 'exord');

                }
                else {
                  this.generalService.notify_msg('error', res.msg);

                  this.router.navigateByUrl('/test', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate([AppFrontRoutes.SERVICING_VIEW + '/' + this.id]);
                    });
                    localStorage.setItem('selectedVal', 'exord');

                }



              });

        });
  }

  delete_ordinary(ID) {

    this.confirmationDialogService.confirm('Servicing Delete Confirmation', 'Do you want to delete this?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.delete_ordinary(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });
  }


  delete_sdocuments(ID) {

    this.confirmationDialogService.confirm('Servicing Documents Delete Confirmation', 'Do you want to delete this?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.delete_sdocuments(ID)
            .subscribe(
              (res) => {
                // if (res.status)
                //   this.success(res.msg);
                // else
                //   this.error(res.msg);

                if (res.status) {
                  this.generalService.notify_msg('success', res.msg);
              
                  this.router.navigateByUrl('/test', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate([AppFrontRoutes.SERVICING_VIEW + '/' + this.id]);
                    });
                    localStorage.setItem('selectedVal', 'documents');
              
                }
                else {
                  this.generalService.notify_msg('error', res.msg);
              
                  this.router.navigateByUrl('/test', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate([AppFrontRoutes.SERVICING_VIEW + '/' + this.id]);
                    });
                    localStorage.setItem('selectedVal', 'documents');
              
              
                }


              });

        });
  }


  turnoff(sID, pid, rid) {

    this.confirmationDialogService.confirm('Servicing Delete Confirmation', 'Are you sure to deactivate?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.turnoff(sID, pid, rid)
            .subscribe(
              (res) => {
                // if (res.status)
                //   this.success(res.msg);
                // else
                //   this.error(res.msg);


                if (res.status) {
                  this.generalService.notify_msg('success', res.msg);

                  this.router.navigateByUrl('/test', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate([AppFrontRoutes.SERVICING_VIEW + '/' + this.id]);
                    });

                  $("#sactivate_plan").modal("hide");
                }
                else {
                  this.generalService.notify_msg('error', res.msg);
                  $("#sactivate_plan").modal("hide");

                  this.router.navigateByUrl('/test', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate([AppFrontRoutes.SERVICING_VIEW + '/' + this.id]);
                    });

                }




              });
          $("#sactivate_plan").modal("hide");
        });
  }

  activate_plan(pid, sId) {

    $("#plan_id_forcd").val(pid);
    $("#pservice_id").val(sId);
    $("#sactivate_plan").modal("show");
  }


  multiDelete() {

    var table1 = new $.fn.dataTable.Api('#table1');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    // console.log('testtest'); return false;

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.multiDelete(selectedRows)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });
        });
  }



  multiDelete1() {

    var table1 = new $.fn.dataTable.Api('#table2');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    // console.log(selectedRows); return false;

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
      .subscribe(
        (confirmed) => {
          if (!confirmed)
            return;

          this.servicingService.delete_mextraordinary(selectedRows)
            .subscribe(
              (res) => {
                // if (res.status)
                //   this.success(res.msg);
                // else
                //   this.error(res.msg);
                localStorage.setItem('selectedVal', 'exord');

                if (res.status) {
                  this.generalService.notify_msg('success', res.msg);

                  this.router.navigateByUrl('/test', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate([AppFrontRoutes.SERVICING_VIEW + '/' + this.id]);
                    });
                }
                else {
                  this.generalService.notify_msg('error', res.msg);

                  this.router.navigateByUrl('/test', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate([AppFrontRoutes.SERVICING_VIEW + '/' + this.id]);
                    });

                }


              });
        });
  }


  doc_multiDelete() {

    var table4 = new $.fn.dataTable.Api('#table4');
    let selectedRows = table4.rows({ selected: true }).ids().toArray();

    // console.log(selectedRows); return false;

    this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
      .subscribe(
        (confirmed) => {
          if (!confirmed)
            return;

          this.servicingService.delete_msdocuments(selectedRows)
            .subscribe(
              (res) => {
                // if (res.status)
                //   this.success(res.msg);
                // else
                //   this.error(res.msg);

                if (res.status) {
                  this.generalService.notify_msg('success', res.msg);

                  this.router.navigateByUrl('/test', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate([AppFrontRoutes.SERVICING_VIEW + '/' + this.id]);
                    });
                    localStorage.setItem('selectedVal', 'documents');

                }
                else {
                  this.generalService.notify_msg('error', res.msg);

                  this.router.navigateByUrl('/test', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate([AppFrontRoutes.SERVICING_VIEW + '/' + this.id]);
                    });
                    localStorage.setItem('selectedVal', 'documents');


                }



              });
        });
  }


  deleteMultiOrdinary() {
    // console.log('sss1');
    var vcnt = $('th:first-child input').val();
    var oid = $('#dmulval').val();

    if (oid != "") {
      // console.log(oid);
      this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
        .subscribe(
          (confirmed) => {

            if (!confirmed)
              return;

            this.servicingService.deleteMultiOrdinary(oid)
              .subscribe(
                (res) => {
                  if (res.status)
                    this.success(res.msg);
                  else
                    this.error(res.msg);
                });
          });


    }
    else {
      for (let i = 1; i <= vcnt; i++) {
        // console.log(i);
        if ($('.chk' + i).is(":checked")) {
          var table3 = new $.fn.dataTable.Api('.otable' + i);
          // var table3 = new $.fn.dataTable.Api('.otable3');
          let selectedRows = table3.rows({ selected: true }).ids().toArray();

          this.confirmationDialogService.confirm('User Confirmation', 'Are you sure to delete the selected rows?')
            .subscribe(
              (confirmed) => {

                if (!confirmed)
                  return;

                this.servicingService.deleteMultiOrdinary(selectedRows)
                  .subscribe(
                    (res) => {
                      if (res.status)
                        this.success(res.msg);
                      else
                        this.error(res.msg);
                    });
              });
        }
      }
    }

  }


  multiDuplicate() {

    var table2 = new $.fn.dataTable.Api('#table2');
    let selectedRows = table2.rows({ selected: true }).ids().toArray();


    this.servicingService.multiExtraDuplicate(selectedRows)
      .subscribe(
        (res) => {
          // if (res.status)
          //   this.success(res.msg);
          // else
          //   this.error(res.msg);

          if (res.status) {
            this.generalService.notify_msg('success', res.msg);

            this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.SERVICING_VIEW + '/' + this.id]);
              });
            localStorage.setItem('selectedVal', 'exord');

          }
          else {
            this.generalService.notify_msg('error', res.msg);

            this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.SERVICING_VIEW + '/' + this.id]);
              });
            localStorage.setItem('selectedVal', 'exord');


          }



        });

  }

  multiOrdDuplicate() {

    let vcnt = $('th:first-child input').val();
    for (let i = 1; i <= vcnt; i++) {
      if ($('.chk' + i).is(":checked")) {
        var table3 = new $.fn.dataTable.Api('.otable' + i);
        let selectedRows = table3.rows({ selected: true }).ids().toArray();

        this.servicingService.multiOrdDuplicate(selectedRows)
          .subscribe(
            (res) => {
              if (res.status)
                this.success(res.msg);
              else
                this.error(res.msg);
            });
      }
    }

  }

  doc_multiDuplicate() {

    var table3 = new $.fn.dataTable.Api('#table4');
    let selectedRows = table3.rows({ selected: true }).ids().toArray();


    this.servicingService.doc_multiDuplicate(selectedRows)
      .subscribe(
        (res) => {
          // if (res.status)
          //   this.success(res.msg);
          // else
          //   this.error(res.msg);

          if (res.status) {
            this.generalService.notify_msg('success', res.msg);

            this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.SERVICING_VIEW + '/' + this.id]);
              });
              localStorage.setItem('selectedVal', 'documents');

          }
          else {
            this.generalService.notify_msg('error', res.msg);

            this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.SERVICING_VIEW + '/' + this.id]);
              });

              localStorage.setItem('selectedVal', 'documents');

          }



        });

  }

  duplicate(ID) {

    this.confirmationDialogService.confirm('Duplicate Confirmation', 'Are you sure you duplicate this line?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.servicingService.duplicate(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
              });

        });


  }




  onPhotoPickerChange(ev) {
    let file = ev.target.files[0];
    file = ev.target.files[0];

    // console.log(file.name);
    let file_name = file.name;
    if (!(/\.(csv)$/i).test(file_name)) {
      alert('Please upload valid excel file_name .csv only.');
      $('#file').val('');
    }
    else {
      let fs = new FileReader();
      fs.onload = (res: any) => {
        this.getPhotoBase64 = res.target.result;
        $('#profile_input').val('');
      };
      fs.readAsDataURL(file);
    }
  }

  onclick() {
    let profileImage = this.getPhotoBase64 ? this.getPhotoBase64.split(',').pop() : this.getPhotoBase64;

    if (profileImage != undefined && $('#file').val() != '') {
      this.servicingService.updateImport(profileImage)
        .subscribe(
          (res) => {
            if (res.status) {
              // this.success(res.msg);
              $("#datatableExport4").modal("hide");

              this.generalService.notify_msg('success', res.msg);

              
              this.router.navigateByUrl('/test', { skipLocationChange: true })
                .then(() => {
                  this.router.navigate([AppFrontRoutes.SERVICING_VIEW+'/'+this.id]);
                });
                localStorage.setItem('selectedVal', 'documents');


            }
            else {
              // this.error(res.msg);
              $("#datatableExport4").modal("hide");

              this.generalService.notify_msg('error', res.msg);

              this.router.navigateByUrl('/test', { skipLocationChange: true })
                .then(() => {
                  this.router.navigate([AppFrontRoutes.SERVICING_VIEW+'/'+this.id]);
                });
                localStorage.setItem('selectedVal', 'documents');

            }
          });
    }
  }


  onSubmit(data) {

    // console.log(data.date); return false;

    var plan_id_forcd = $("#plan_id_forcd").val();
    var pservice_id = $("#pservice_id").val();

    if (data.date != "") {
      this.servicingService.active_status(data.date, plan_id_forcd, pservice_id)
        .subscribe(
          (res) => {
            // if (res.status) {
            //   this.success(res.msg);
            //   $("#sactivate_plan").modal("hide");
            // }
            // else {
            //   this.error(res.msg);
            //   $("#sactivate_plan").modal("hide");

            // }

            if (res.status) {
              this.generalService.notify_msg('success', res.msg);

              this.router.navigateByUrl('/test', { skipLocationChange: true })
                .then(() => {
                  this.router.navigate([AppFrontRoutes.SERVICING_VIEW + '/' + this.id]);
                });

              $("#sactivate_plan").modal("hide");
              localStorage.setItem('selectedVal', 'general');

            }
            else {
              this.generalService.notify_msg('error', res.msg);
              $("#sactivate_plan").modal("hide");


              this.router.navigateByUrl('/test', { skipLocationChange: true })
                .then(() => {
                  this.router.navigate([AppFrontRoutes.SERVICING_VIEW + '/' + this.id]);
                });

              localStorage.setItem('selectedVal', 'general');

            }

          });
    }
    else {
      alert('Please Enter Start Date!!!');
    }

  }

  // add_extraordinary(SID) {
  //   this.extraordinayModal = this.modalService.show(ServicingExtraOrdinaryComponent, { class: 'modal-lgs', initialState: { 'SID': SID, 'langs': this.exodlang } });
  // }

  // edit_extraordinary(ID, SID) {
  //   this.extraordinayModal = this.modalService.show(ServicingExtraOrdinaryComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'SID': SID, 'langs': this.exodlang } });
  // }


  // add_ordinary(SID, PID) {
  //   // console.log(PID);
  //   this.ordinayModal = this.modalService.show(ServicingOrdinaryComponent, { class: 'modal-lgs', initialState: { 'SID': SID, 'PID': PID, 'langs': this.odlang } });
  // }

  // edit_ordinary(ID, SID, PID) {
  //   this.ordinayModal = this.modalService.show(ServicingOrdinaryComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'SID': SID, 'PID': PID, 'langs': this.odlang, 'action': "edit" } });
  // }


  // duplicate_ordinary(ID, SID, PID) {
  //   this.ordinayModal = this.modalService.show(ServicingOrdinaryComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'SID': SID, 'PID': PID, 'langs': this.odlang, 'action': "duplicate" } });
  // }


  // add_sdocuments(SID) {
  //   console.log(SID);
  //   this.ordinayModal = this.modalService.show(ServicingDocumentsComponent, { class: 'modal-lgs', initialState: { 'SID': SID, 'langs': this.doclang } });
  // }


  // edit_sdocuments(ID, SID) {
  //   this.ordinayModal = this.modalService.show(ServicingDocumentsComponent, { class: 'modal-lgs', initialState: { 'ID': ID, 'SID': SID, 'langs': this.doclang, 'action': 'edit' } });
  // }


}
